import * as adminActionTypes from './adminActionTypes';
import { createReducer } from 'util/Helpers';

import { adminInitialState } from './adminInitialState';

const triggerRequest = (state) => {
  return state + 1;
};

const endRequest = (state) => {
  return state <= 0 ? 0 : state - 1;
};

const allProvidersDetail = (state, action) => {
  if (action.payload) {
    return Object.assign(action.payload);
  }
  return state;
};

const fetchAdminReports = (state, action) => {
  return Object.assign(action.payload);
};

// TODO remove this
const fetchAdminReportsOriginal = (state, action) => {
  return Object.assign(action.payload);
};

const fetchAdminReportDetails = (state, action) => {
  if (action.payload) {
    return Object.assign({}, state, action.payload);
  }
  return {};
};

const clearAdminReportDetails = () => {
  return {};
};

const fetchAllAgents = (state, action) => {
  if (action.payload) {
    return Object.assign(action.payload);
  }
  return {};
};

const fetchPenaltyDetails = (state, action) => {
  if (action.payload) {
    return {
      ...state,
      order: {
        ...state.order,
        cancellationCharges: action.payload.cancellationCharges,
        nonRefundableCharges: action.payload.nonRefundableCharges,
      },
    };
  }
  return {};
};

const fetchOrderCancellationPenaltiesV5 = (state, action) => {
  if (action.payload) {
    return {
      ...state,
      order: {
        ...state.order,
        cancellationPenalties: action.payload.cancellationPenalties,
      },
    };
  }
  return {};
};

const fetchBusCancellationPenalties = (state, action) => {
  if (action.payload) {
    return {
      ...state,
      order: {
        ...state.order,
        busCancellationPenalties: action.payload.busCancellationPenalties,
      },
    };
  }
  return {};
};

const fetchReIssuanceDetail = (state, action) => {
  if (action.payload) {
    return Object.assign(action.payload);
  }
  return {};
};

const paymentReducer = createReducer(
  {},
  {
    [adminActionTypes.GET_PROVIDERS]: allProvidersDetail,
  }
);
const requestReducer = createReducer(
  {},
  {
    [adminActionTypes.TRIGGER_REQUEST]: triggerRequest,
    [adminActionTypes.END_REQUEST]: endRequest,
  }
);
const adminReportReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_REPORTS]: fetchAdminReports,
  }
);
const adminReportOriginalReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_REPORTS_ORIGINAL]: fetchAdminReportsOriginal,
  }
);

const adminReportDetailsReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_REPORT_DETAILS]: fetchAdminReportDetails,
    [adminActionTypes.ORDER_PENALTIES]: fetchPenaltyDetails,
    [adminActionTypes.ORDER_CANCELLATION_PENALTIES_V5]: fetchOrderCancellationPenaltiesV5,
    [adminActionTypes.CLEAR_ADMIN_REPORT]: clearAdminReportDetails,
  }
);
const adminHotelReportDetailsReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_HOTEL_REPORT_DETAILS]: fetchAdminReportDetails,
    [adminActionTypes.CLEAR_ADMIN_REPORT]: clearAdminReportDetails,
  }
);
const adminTourReportDetailsReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_TOUR_REPORT_DETAILS]: fetchAdminReportDetails,
    [adminActionTypes.CLEAR_ADMIN_REPORT]: clearAdminReportDetails,
  }
);
const adminBusReportDetailsReducer = createReducer(
  {},
  {
    [adminActionTypes.ADMIN_BUS_REPORT_DETAILS]: fetchAdminReportDetails,
    [adminActionTypes.ADMIN_BUS_CANCELLATION_PENALTIES]: fetchBusCancellationPenalties,
    [adminActionTypes.CLEAR_ADMIN_REPORT]: clearAdminReportDetails,
  }
);

const allAgentsReducer = createReducer(
  {},
  {
    [adminActionTypes.FETCH_ALL_AGENTS]: fetchAllAgents,
  }
);

const reIssuancDetailReducer = createReducer(
  {},
  {
    [adminActionTypes.GET_REISSUANCE_DETAILS]: fetchReIssuanceDetail,
  }
);

// --- Airline vouchers ---

const setAirlineVouchers = (state, action) => {
  if (action.payload) {
    return Object.assign({}, action.payload);
  }
  return state;
};

const setAirlineVoucherDetail = (state, action) => {
  if (action.payload) {
    return Object.assign({}, action.payload);
  }
  return null;
};

const clearAirlineVoucherDetail = () => null;

const setAirlineVoucherSupportedAirlines = (state, action) => {
  return Array.isArray(action.payload) ? action.payload : [];
};

const airlineVouchersReducer = createReducer(null, {
  [adminActionTypes.AIRLINE_VOUCHERS]: setAirlineVouchers,
});

const airlineVoucherDetailReducer = createReducer(null, {
  [adminActionTypes.AIRLINE_VOUCHER_DETAIL]: setAirlineVoucherDetail,
  [adminActionTypes.CLEAR_AIRLINE_VOUCHER_DETAIL]: clearAirlineVoucherDetail,
});

const airlineVoucherSupportedAirlinesReducer = createReducer([], {
  [adminActionTypes.AIRLINE_VOUCHER_AIRLINES]: setAirlineVoucherSupportedAirlines,
});

// --- Refund requests (view-only list) ---

const REFUND_REQUESTS_INITIAL = { requestsData: [], count: 0, next: false, previous: false };

const setRefundRequests = (state, action) => {
  if (action.payload) {
    return Object.assign({}, action.payload);
  }
  return state;
};

const refundRequestsReducer = createReducer(REFUND_REQUESTS_INITIAL, {
  [adminActionTypes.REFUND_REQUESTS]: setRefundRequests,
});

// --- Losses (review queue) ---

const LOSSES_INITIAL = { lossesData: [], count: 0, next: false, previous: false };

const setLossReports = (state, action) => {
  if (action.payload) {
    return Object.assign({}, action.payload);
  }
  return state;
};

// A single report changed (approved / amended / rejected / voided / corrected).
// Patch it in place so an open list does not need a full refetch to look right.
const patchLossReport = (state, action) => {
  const updated = action.payload;
  if (!updated || !state?.lossesData) return state;
  return Object.assign({}, state, {
    lossesData: state.lossesData.map((row) => (row.id === updated.id ? updated : row)),
  });
};

const lossReportsReducer = createReducer(LOSSES_INITIAL, {
  [adminActionTypes.LOSS_REPORTS]: setLossReports,
  [adminActionTypes.LOSS_REPORT_UPDATED]: patchLossReport,
});

// Per-order panel data, keyed by order id so two order tabs cannot clobber
// each other's list.
const setOrderLossReports = (state, action) => {
  const { orderId, reports } = action.payload || {};
  if (!orderId) return state;
  return Object.assign({}, state, { [orderId]: reports || [] });
};

const orderLossReportsReducer = createReducer(
  {},
  {
    [adminActionTypes.ORDER_LOSS_REPORTS]: setOrderLossReports,
  }
);

// --- Losses (what this user may do) ---

const CAPABILITIES_INITIAL = { loaded: false, canReportLoss: false, canReviewLoss: false };

// Replaced wholesale, never merged: a role that was taken away has to be able
// to come back as false, and a partial merge would leave the old `true` behind.
const setLossCapabilities = (state, action) =>
  Object.assign({}, CAPABILITIES_INITIAL, action.payload, { loaded: true });

const lossCapabilitiesReducer = createReducer(CAPABILITIES_INITIAL, {
  [adminActionTypes.LOSS_CAPABILITIES]: setLossCapabilities,
});

const AdminReducer = (state = adminInitialState, action) => ({
  // eslint-disable-next-line new-cap
  adminReports: adminReportReducer(state.adminReports, action),
  adminReportOriginal: adminReportOriginalReducer(state.adminReportOriginal, action),
  adminReportDetails: adminReportDetailsReducer(state.adminReportDetails, action),
  adminHotelReportDetails: adminHotelReportDetailsReducer(state.adminHotelReportDetails, action),
  adminTourReportDetails: adminTourReportDetailsReducer(state.adminTourReportDetails, action),
  adminBusReportDetails: adminBusReportDetailsReducer(state.adminBusReportDetails, action),
  allAgents: allAgentsReducer(state.allAgents, action),
  fetchCount: requestReducer(state.fetchCount, action),
  paymentProviders: paymentReducer(state.paymentProviders, action),
  reIssuanceDetail: reIssuancDetailReducer(state.reIssuanceDetail, action),
  airlineVouchers: airlineVouchersReducer(state.airlineVouchers, action),
  lossReports: lossReportsReducer(state.lossReports, action),
  orderLossReports: orderLossReportsReducer(state.orderLossReports, action),
  lossCapabilities: lossCapabilitiesReducer(state.lossCapabilities, action),
  airlineVoucherDetail: airlineVoucherDetailReducer(state.airlineVoucherDetail, action),
  airlineVoucherSupportedAirlines: airlineVoucherSupportedAirlinesReducer(
    state.airlineVoucherSupportedAirlines,
    action
  ),
  refundRequests: refundRequestsReducer(state.refundRequests, action),
});

export default AdminReducer;
